import { getApiB2bPackageByIdComparison } from '/api/sdk.gen';

import getPackageIdFromApplicationSelector from '/business/shared/state/selectors/application/getPackageIdFromApplicationSelector';

import ValidationError from '/shared/errors/ValidationError';
import normaliseError, { toNormaliseErrorInput } from '/shared/functions/normaliseError';
import type { AppDispatch, RootState } from '/business/shared/state/store';

const getApplicationPackageComparison = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  const packageId = getPackageIdFromApplicationSelector(getState());
  try {
    dispatch({ type: 'GET_APPLICATION_PACKAGE_COMPARISON_STARTED', packageId });
    const { data: payload } = await getApiB2bPackageByIdComparison({ path: { id: String(packageId) } });
    dispatch({ type: 'GET_APPLICATION_PACKAGE_COMPARISON_FULFILLED', packageId, payload });
  } catch (error) {
    if (error instanceof ValidationError) {
      dispatch({ type: 'GET_APPLICATION_PACKAGE_COMPARISON_REJECTED', error });
    } else {
      dispatch({
        type: 'GET_APPLICATION_PACKAGE_COMPARISON_REJECTED',
        error: normaliseError(toNormaliseErrorInput(error), 'GET_APPLICATION_PACKAGE_COMPARISON'),
      });
    }
    throw error;
  }
};

export default getApplicationPackageComparison;
